var _rect, _path, _path2, _circle, _path3, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeurotide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#082f49"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 300c120-100 180 100 300 0s180-100 300 0 180 100 300 0v220H0z",
    fill: "#0369a1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 360c120-100 180 100 300 0s180-100 300 0 180 100 300 0",
    fill: "none",
    stroke: "#67e8f9",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 170,
    r: 70,
    fill: "#22d3ee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M400 125v90M355 170h90M370 140l60 60M430 140l-60 60",
    stroke: "#083344",
    strokeWidth: 9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fill: "#cffafe",
    fontFamily: "sans-serif",
    fontSize: 48,
    fontWeight: 700
  }, "NEUROTIDE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 475,
    fill: "#7dd3fc",
    fontFamily: "monospace",
    fontSize: 22
  }, "AI-ASSISTED P2P STREAMING")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeurotide);
export default __webpack_public_path__ + "static/media/neurotide.7b685eb6795549783662fc8d82b948a5.svg";
export { ForwardRef as ReactComponent };